(function () {
  const STORAGE_KEY = 'aviWishlist';
  const DESKTOP_BREAKPOINT = 990;
  const HIDE_THRESHOLD = 8;

  function getWishlistCount() {
    if (window.AviWishlist && typeof window.AviWishlist.getWishlist === 'function') {
      return window.AviWishlist.getWishlist().length;
    }

    try {
      const handles = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(handles) ? handles.filter(Boolean).length : 0;
    } catch (error) {
      return 0;
    }
  }

  function updateWishlistCounts(root) {
    const count = getWishlistCount();
    root.querySelectorAll('[data-avi-wishlist-count]').forEach((element) => {
      element.textContent = count > 99 ? '99+' : String(count);
      element.hidden = count === 0;
    });
  }

  const WISHLIST_ICON_PATH =
    'M12 6.85l-1.18-1.16C9.42 4.31 7.15 4.31 5.75 5.69 4.35 7.07 4.35 9.31 5.75 10.69L12 16.86l6.25-6.17c1.4-1.38 1.4-3.62 0-5-1.4-1.38-3.67-1.38-5.07 0L12 6.85Z';

  const WISHLIST_ICON_SVG = `
    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24">
      <path d="${WISHLIST_ICON_PATH}"></path>
    </svg>
  `;

  function syncProductWishlistIcons(root = document) {
    root.querySelectorAll('[data-avi-wishlist-button]').forEach((button) => {
      const iconContainer = button.querySelector('.avi-wishlist-icon') || button;
      const existingSvg = iconContainer.querySelector('svg');
      const existingPath = existingSvg?.querySelector('path')?.getAttribute('d');

      if (existingPath === WISHLIST_ICON_PATH) {
        button.dataset.aviWishlistIconSynced = 'true';
        return;
      }

      if (existingSvg) {
        existingSvg.outerHTML = WISHLIST_ICON_SVG;
      } else if (button.querySelector('.avi-wishlist-icon')) {
        iconContainer.innerHTML = WISHLIST_ICON_SVG;
      } else {
        iconContainer.insertAdjacentHTML('afterbegin', WISHLIST_ICON_SVG);
      }

      button.dataset.aviWishlistIconSynced = 'true';
    });
  }

  function isDesktop() {
    return window.innerWidth >= DESKTOP_BREAKPOINT;
  }

  function updateHeaderBottom(header) {
    const rect = header.getBoundingClientRect();
    header.style.setProperty('--avi-header-bottom', `${Math.max(0, rect.bottom)}px`);
  }

  function updatePrimaryMenuMetrics(header) {
    const items = Array.from(header.querySelectorAll('[data-avi-primary-menu-item]')).filter((item) => {
      const rect = item.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0;
    });

    if (!items.length || !isDesktop()) return;

    const firstRect = items[0].getBoundingClientRect();
    const lastRect = items[items.length - 1].getBoundingClientRect();
    const left = Math.max(0, firstRect.left);
    const width = Math.max(0, lastRect.right - firstRect.left);
    const baseWidth = Math.min(Math.max(width, 280), 360);

    header.style.setProperty('--avi-primary-menu-left', `${left}px`);
    header.style.setProperty('--avi-primary-menu-width', `${width}px`);
    header.style.setProperty('--avi-mega-menu-base-width', `${baseWidth}px`);
  }

  function updateMegaContentPosition(header, item) {
    if (!item) return;

    const itemRect = item.getBoundingClientRect();
    if (itemRect.width > 0) {
      const itemCenter = itemRect.left + itemRect.width / 2;
      header.style.setProperty('--avi-hover-item-left', `${itemCenter}px`);
    }
  }

  function setHeaderHidden(header, isHidden) {
    header.classList.toggle('is-hidden', isHidden);
    header.classList.toggle('avi-header--hidden', isHidden);
    header.classList.toggle('avi-custom-header--hidden', isHidden);
  }

  function updateStickyOffset(header) {
    return;
  }

  function isStickyProtected(header) {
    return (
      header.classList.contains('avi-mega-menu-open') ||
      document.body.classList.contains('avi-custom-header-drawer-open') ||
      header.matches(':hover') ||
      header.matches(':focus-within')
    );
  }

  function getStickySection(header) {
    return header.closest('.shopify-section');
  }

  function updateSectionStickyState(header) {
    const stickyMode = header.dataset.stickyMode || 'none';
    const isSticky = stickyMode === 'sticky' || stickyMode === 'always';
    const sectionWrapper = getStickySection(header);

    if (!sectionWrapper) return;

    if (!isSticky) {
      sectionWrapper.classList.remove('avi-custom-header-section--stuck');
      sectionWrapper.style.removeProperty('--avi-header-section-height');
      return;
    }

    const headerHeight = header.offsetHeight || 0;
    if (headerHeight) {
      sectionWrapper.style.setProperty('--avi-header-section-height', `${headerHeight}px`);
    }

    if (!sectionWrapper.dataset.aviStickyTop) {
      const sectionTop = sectionWrapper.getBoundingClientRect().top + window.scrollY;
      sectionWrapper.dataset.aviStickyTop = String(sectionTop);
    }

    const stickyTop = Number(sectionWrapper.dataset.aviStickyTop || 0);
    const shouldStick = window.scrollY >= Math.max(0, stickyTop);

    sectionWrapper.classList.toggle('avi-custom-header-section--stuck', shouldStick);
  }

  function recalculateStickyTop(header) {
    const sectionWrapper = getStickySection(header);
    if (!sectionWrapper) return;

    sectionWrapper.classList.remove('avi-custom-header-section--stuck');
    sectionWrapper.dataset.aviStickyTop = String(sectionWrapper.getBoundingClientRect().top + window.scrollY);
    updateSectionStickyState(header);
  }

  function syncStickyMode(header) {
    const stickyMode = header.dataset.stickyMode || 'none';
    const isSticky = stickyMode === 'sticky' || stickyMode === 'always';
    const sectionWrapper = getStickySection(header);

    header.classList.toggle('avi-custom-header--sticky', isSticky);
    if (sectionWrapper) {
      sectionWrapper.classList.toggle('avi-custom-header-section--sticky', isSticky);
      if (!isSticky) {
        sectionWrapper.classList.remove('avi-custom-header-section--stuck');
        sectionWrapper.style.removeProperty('--avi-header-section-height');
        delete sectionWrapper.dataset.aviStickyTop;
      } else if (!sectionWrapper.dataset.aviStickyTop) {
        recalculateStickyTop(header);
      }
    }

    header.classList.remove('avi-header--sticky');
    setHeaderHidden(header, false);
    updateStickyOffset(header);
    updateSectionStickyState(header);
  }

  function closeMegaMenu(header, item, panel) {
    item.classList.remove('is-open');
    if (panel) panel.classList.remove('is-open');

    if (!header.querySelector('.avi-custom-header__menu-item.is-open')) {
      header.classList.remove('avi-mega-menu-open');
    }
  }

  function openMegaMenu(header, item, panel) {
    header.querySelectorAll('.avi-custom-header__menu-item.is-open').forEach((openItem) => {
      if (openItem !== item) {
        closeMegaMenu(header, openItem, openItem.querySelector('[data-avi-mega-menu]'));
      }
    });

    item.classList.add('is-open');
    if (panel) panel.classList.add('is-open');
    header.classList.add('avi-mega-menu-open');
    setHeaderHidden(header, false);
  }

  function closeDropdown(header, item, panel) {
    item.classList.remove('is-dropdown-open');
    if (panel) panel.classList.remove('is-open');
  }

  function openDropdown(header, item, panel) {
    header.querySelectorAll('.avi-custom-header__menu-item.is-dropdown-open').forEach((openItem) => {
      if (openItem !== item) {
        closeDropdown(header, openItem, openItem.querySelector('.avi-custom-header__dropdown'));
      }
    });

    item.classList.add('is-dropdown-open');
    if (panel) panel.classList.add('is-open');
  }

  function activateMegaPanel(layout, panelId) {
    if (!layout || !panelId) return;

    layout.querySelectorAll('[data-avi-mega-primary]').forEach((trigger) => {
      const isActive = trigger.dataset.megaPanelId === panelId;
      trigger.classList.toggle('is-active', isActive);
      trigger.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    layout.querySelectorAll('[data-avi-mega-panel]').forEach((panel) => {
      panel.classList.toggle('is-active', panel.id === panelId);
    });
  }

  function initAssociatedMegaMenus(header) {
    header.querySelectorAll('[data-avi-mega-layout]').forEach((layout) => {
      const triggers = layout.querySelectorAll('[data-avi-mega-primary]');
      const firstTrigger = triggers[0];

      if (firstTrigger) {
        activateMegaPanel(layout, firstTrigger.dataset.megaPanelId);
      }

      triggers.forEach((trigger) => {
        const panelId = trigger.dataset.megaPanelId;
        trigger.addEventListener('pointerenter', () => activateMegaPanel(layout, panelId));
        trigger.addEventListener('focus', () => activateMegaPanel(layout, panelId));
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          activateMegaPanel(layout, panelId);
        });
      });
    });
  }

  function closeMobileMegaPages(header, restoreTrigger) {
    header.querySelectorAll('[data-avi-mobile-mega-page].is-active').forEach((page) => {
      page.classList.remove('is-active');
      page.setAttribute('aria-hidden', 'true');
    });

    header.querySelectorAll('[data-avi-mobile-mega-open][aria-expanded="true"]').forEach((trigger) => {
      trigger.setAttribute('aria-expanded', 'false');
      if (restoreTrigger) trigger.focus();
    });
  }

  function openMobileMegaPage(header, pageId, trigger) {
    const escapedPageId =
      window.CSS && typeof window.CSS.escape === 'function'
        ? window.CSS.escape(pageId)
        : pageId.replace(/[^a-zA-Z0-9_-]/g, '\\$&');
    const page = header.querySelector(`#${escapedPageId}`);
    if (!page) return;

    closeMobileMegaPages(header, false);
    page.classList.add('is-active');
    page.setAttribute('aria-hidden', 'false');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');

    const backButton = page.querySelector('[data-avi-mobile-mega-back]');
    if (backButton) backButton.focus();
  }

  function closeDrawer(header, options) {
    const drawer = header.querySelector('[data-avi-mobile-drawer]');
    const overlay = header.querySelector('[data-avi-drawer-overlay]');
    const toggle = header.querySelector('[data-avi-mobile-toggle]');

    if (!drawer || !overlay || !toggle) return;

    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.classList.remove('is-active');
    overlay.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'Open menu');
    document.body.classList.remove('avi-custom-header-drawer-open');

    header.querySelectorAll('.avi-custom-header__mobile-details[open]').forEach((details) => {
      details.removeAttribute('open');
    });
    closeMobileMegaPages(header, false);

    if (options && options.restoreFocus) {
      toggle.focus();
    }
  }

  function openDrawer(header) {
    const drawer = header.querySelector('[data-avi-mobile-drawer]');
    const overlay = header.querySelector('[data-avi-drawer-overlay]');
    const toggle = header.querySelector('[data-avi-mobile-toggle]');
    const closeButton = header.querySelector('[data-avi-mobile-close]');

    if (!drawer || !overlay || !toggle) return;

    setHeaderHidden(header, false);
    overlay.hidden = false;
    window.requestAnimationFrame(() => {
      overlay.classList.add('is-active');
      drawer.classList.add('is-open');
    });
    drawer.setAttribute('aria-hidden', 'false');
    toggle.setAttribute('aria-expanded', 'true');
    toggle.setAttribute('aria-label', 'Close menu');
    document.body.classList.add('avi-custom-header-drawer-open');
    updateHeaderBottom(header);

    if (closeButton) {
      closeButton.focus();
    }
  }

  function isProtectedInteraction(header) {
    const drawer = header.querySelector('[data-avi-mobile-drawer]');
    const activeCartDialog = header.querySelector('.cart-drawer__dialog[open]');
    const drawerOpen = drawer && drawer.classList.contains('is-open');

    return header.matches(':hover') || header.matches(':focus-within') || drawerOpen || activeCartDialog;
  }

  function initHeader(header) {
    const toggle = header.querySelector('[data-avi-mobile-toggle]');
    const overlay = header.querySelector('[data-avi-drawer-overlay]');
    const closeButton = header.querySelector('[data-avi-mobile-close]');
    const stickyMode = header.dataset.stickyMode;
    let lastScrollY = window.scrollY;
    let ticking = false;

    const syncMeasurements = () => {
      updateHeaderBottom(header);
      updatePrimaryMenuMetrics(header);
      updateStickyOffset(header);
      updateSectionStickyState(header);
    };

    syncStickyMode(header);

    if (toggle) {
      toggle.addEventListener('click', () => {
        const drawer = header.querySelector('[data-avi-mobile-drawer]');
        if (drawer && drawer.classList.contains('is-open')) {
          closeDrawer(header, { restoreFocus: true });
        } else {
          openDrawer(header);
        }
      });
    }

    if (overlay) {
      overlay.addEventListener('click', () => closeDrawer(header, { restoreFocus: true }));
    }

    if (closeButton) {
      closeButton.addEventListener('click', () => closeDrawer(header, { restoreFocus: true }));
    }

    initAssociatedMegaMenus(header);

    header.querySelectorAll('[data-avi-mobile-mega-open]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        openMobileMegaPage(header, trigger.dataset.aviMobileMegaOpen, trigger);
      });
    });

    header.querySelectorAll('[data-avi-mobile-mega-back]').forEach((button) => {
      button.addEventListener('click', () => closeMobileMegaPages(header, true));
    });

    header.querySelectorAll('[data-avi-primary-menu-item]').forEach((item) => {
      const panel = item.querySelector('[data-avi-mega-menu]');
      const dropdown = item.querySelector('.avi-custom-header__dropdown');
      let closeTimer;
      let dropdownCloseTimer;

      const clearCloseTimer = () => {
        if (closeTimer) {
          window.clearTimeout(closeTimer);
          closeTimer = null;
        }
      };

      const scheduleClose = () => {
        if (!panel) return;
        clearCloseTimer();
        closeTimer = window.setTimeout(() => {
          if (!item.matches(':hover') && !panel.matches(':hover') && !item.matches(':focus-within')) {
            closeMegaMenu(header, item, panel);
          }
        }, 220);
      };

      const clearDropdownCloseTimer = () => {
        if (dropdownCloseTimer) {
          window.clearTimeout(dropdownCloseTimer);
          dropdownCloseTimer = null;
        }
      };

      const scheduleDropdownClose = () => {
        if (!dropdown) return;
        clearDropdownCloseTimer();
        dropdownCloseTimer = window.setTimeout(() => {
          if (!item.matches(':hover') && !dropdown.matches(':hover') && !item.matches(':focus-within')) {
            closeDropdown(header, item, dropdown);
          }
        }, 220);
      };

      item.addEventListener('pointerenter', () => {
        syncMeasurements();
        updateMegaContentPosition(header, item);
        if (panel) {
          clearCloseTimer();
          openMegaMenu(header, item, panel);
          window.requestAnimationFrame(() => updateMegaContentPosition(header, item));
          return;
        }
        if (dropdown) {
          clearDropdownCloseTimer();
          openDropdown(header, item, dropdown);
        }
      });
      item.addEventListener('pointerleave', () => {
        scheduleClose();
        scheduleDropdownClose();
      });
      item.addEventListener('focusin', () => {
        syncMeasurements();
        updateMegaContentPosition(header, item);
        if (panel) {
          clearCloseTimer();
          openMegaMenu(header, item, panel);
          window.requestAnimationFrame(() => updateMegaContentPosition(header, item));
          return;
        }
        if (dropdown) {
          clearDropdownCloseTimer();
          openDropdown(header, item, dropdown);
        }
      });

      if (panel) {
        panel.addEventListener('pointerenter', () => {
          clearCloseTimer();
          openMegaMenu(header, item, panel);
        });
        panel.addEventListener('pointerleave', scheduleClose);
      }

      if (dropdown) {
        dropdown.addEventListener('pointerenter', () => {
          clearDropdownCloseTimer();
          openDropdown(header, item, dropdown);
        });
        dropdown.addEventListener('pointerleave', scheduleDropdownClose);
      }
    });

    const onScroll = () => {
      if (ticking) return;
      ticking = true;

      window.requestAnimationFrame(() => {
        const currentScrollY = Math.max(0, window.scrollY);
        const delta = currentScrollY - lastScrollY;

        header.classList.toggle('is-scrolled', currentScrollY > 4);
        syncMeasurements();

        setHeaderHidden(header, false);

        lastScrollY = currentScrollY;
        ticking = false;
      });
    };

    const onResize = () => {
      recalculateStickyTop(header);
      syncMeasurements();
      syncStickyMode(header);

      if (isDesktop()) {
        closeDrawer(header);
        setHeaderHidden(header, false);
        if (toggle) {
          toggle.setAttribute('aria-expanded', 'false');
          toggle.setAttribute('aria-label', 'Open menu');
        }
      }
    };

    const onKeyDown = (event) => {
      if (event.key === 'Escape') {
        closeDrawer(header, { restoreFocus: true });
      }
    };

    updateWishlistCounts(header);
    syncMeasurements();

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);
    document.addEventListener('keydown', onKeyDown);

    if (document.fonts && typeof document.fonts.ready?.then === 'function') {
      document.fonts.ready.then(syncMeasurements).catch(() => {});
    }

    document.addEventListener('shopify:section:load', syncMeasurements);
    document.addEventListener('shopify:section:select', syncMeasurements);

    header.addEventListener('pointerenter', () => {
      setHeaderHidden(header, false);
      syncMeasurements();
    });
    header.addEventListener('focusin', () => {
      setHeaderHidden(header, false);
      syncMeasurements();
    });
  }

  function init() {
    const headers = document.querySelectorAll('[data-avi-custom-header]');
    headers.forEach(initHeader);
    syncProductWishlistIcons();

    window.addEventListener('storage', (event) => {
      if (event.key === STORAGE_KEY) {
        headers.forEach(updateWishlistCounts);
        syncProductWishlistIcons();
      }
    });

    window.addEventListener('avi:wishlist:updated', () => {
      headers.forEach(updateWishlistCounts);
      syncProductWishlistIcons();
    });

    document.addEventListener('shopify:section:load', (event) => {
      syncProductWishlistIcons(event.target || document);
    });

    let wishlistIconFrame = null;
    const wishlistIconObserver = new MutationObserver(() => {
      if (wishlistIconFrame) return;
      wishlistIconFrame = window.requestAnimationFrame(() => {
        syncProductWishlistIcons();
        wishlistIconFrame = null;
      });
    });

    wishlistIconObserver.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
